
import { useState } from 'react';

interface FAQ {
  id: number;
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  faqs: FAQ[];
}

const FAQAccordion = ({ faqs }: FAQAccordionProps) => {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleFAQ = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="space-y-4">
      {faqs.map((faq, index) => (
        <div
          key={faq.id}
          className={`rounded-lg overflow-hidden ${
            index % 2 === 0 ? 'bg-white' : 'bg-lightgray'
          }`}
        >
          <button
            onClick={() => toggleFAQ(faq.id)}
            className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-greenbg/30 transition-colors cursor-pointer"
          >
            <h4 className="font-semibold text-charcoal pr-4">{faq.question}</h4>
            <i
              className={`${
                openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'
              } text-primary text-2xl flex-shrink-0 w-6 h-6 flex items-center justify-center`}
            ></i>
          </button>
          {openId === faq.id && (
            <div className="px-6 pb-5">
              <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQAccordion;
